var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { AppConsts } from '../../../../../shared/AppConsts';
var RemoteConfigureSettingsStore = /** @class */ (function () {
    function RemoteConfigureSettingsStore(configureSettingsService, galleryService) {
        this.configureSettingsService = configureSettingsService;
        this.galleryService = galleryService;
    }
    RemoteConfigureSettingsStore.prototype.load = function (configureId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadDesignerSettings()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadDefaultGraphSettings(configureId)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteConfigureSettingsStore.prototype.loadDesignerSettings = function () {
        return __awaiter(this, void 0, Promise, function () {
            var settings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configureSettingsService.getSettings().toPromise()];
                    case 1:
                        settings = _a.sent();
                        this.designerSettings = {
                            isShowGrid: settings.designerSettings.isShowGrid,
                            isGridSnapEnabled: settings.designerSettings.isGridSnapEnabled,
                            isGuidelineSnapEnabled: settings.designerSettings.isGuidelineSnapEnabled
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteConfigureSettingsStore.prototype.loadDefaultGraphSettings = function (configureId) {
        return __awaiter(this, void 0, Promise, function () {
            var graphSettings, settings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.galleryService.getConfigureGraphSettings(configureId).toPromise()];
                    case 1:
                        graphSettings = _a.sent();
                        settings = new Map();
                        graphSettings.forEach(function (value) {
                            settings.set(value.category, { graphId: value.graphId, url: value.url });
                        });
                        this.defaultGraphSettings = { settings: settings };
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteConfigureSettingsStore.prototype.save = function () {
        var settings = {
            designerSettings: {
                isShowGrid: this.designerSettings.isShowGrid,
                isGridSnapEnabled: this.designerSettings.isGridSnapEnabled,
                isGuidelineSnapEnabled: this.designerSettings.isGuidelineSnapEnabled
            }
        };
        var token = abp.auth.getToken();
        if (token) {
            abp.ajax({
                /* 使用同步ajax，异步的调用会在页面关闭的时候被Cancel掉。 */
                async: false,
                headers: {
                    Authorization: 'Bearer ' + token
                },
                url: AppConsts.remoteServiceBaseUrl + '/api/services/app/ConfigureSettings/SaveSettings',
                data: JSON.stringify(settings)
            });
        }
    };
    RemoteConfigureSettingsStore = __decorate([
        Injectable()
    ], RemoteConfigureSettingsStore);
    return RemoteConfigureSettingsStore;
}());
export { RemoteConfigureSettingsStore };
